import Box from 'components/Box';
import CheckBoxUI from './Checkbox';

type Props = {
  value?: 'request' | 'none-request' | 'online';
  onChange?: (value: 'request' | 'none-request' | 'online') => void;
  small?: boolean;
  icon?: boolean;
  service?: boolean;
  quickBookV2?: boolean;
};
const AptStatusHandler = ({ value, onChange, small, quickBookV2, icon, service }: Props) => {
  const onChangeStatus = (value: 'request' | 'none-request' | 'online') => () => onChange?.(value);
  if (service) return (
    <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={{ zoom: 0.7 }}>
      <CheckBoxUI small type='request' value={value === 'request'} onClick={onChangeStatus(value === 'request' ? 'none-request' : 'request')} />
    </Box>
  );
  if (icon) return (
    <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={{ zoom: 0.7 }}>
      <CheckBoxUI icon type='request' value={value === 'request'} onClick={onChangeStatus(value === 'request' ? 'none-request' : 'request')} />
    </Box>
  );
  if (quickBookV2) {
    return (
      <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={{ zoom: 0.7 }}>
        <CheckBoxUI small type='request' value={value === 'request'} onClick={onChangeStatus(value === 'request' ? 'none-request' : 'request')} />
      </Box>
    );
  }
  if (small) {
    return (
      <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={small ? { zoom: 0.75 } : {}}>
        <CheckBoxUI small={small} type='request' value={value === 'request'} onClick={() => onChange?.(value === 'request' ? 'none-request' : 'request')} />
        <CheckBoxUI small={small} type='online' value={value === 'online'} onClick={onChangeStatus('online')} />
      </Box>
    );
  }
  return (
    <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={small ? { zoom: 0.75 } : {}}>
      <CheckBoxUI small={small} type='request' value={value === 'request'} onClick={onChangeStatus('request')} />
      <CheckBoxUI small={small} type='none-request' value={value === 'none-request'} onClick={onChangeStatus('none-request')} />
      <CheckBoxUI small={small} type='online' value={value === 'online'} onClick={onChangeStatus('online')} />
    </Box>
  );
};
export default AptStatusHandler;
